<div class="sam-video" [class.sam-video--full]="fullWidth()">
  @if (!playing()) {
    <div
      class="sam-video__facade"
      role="button"
      tabindex="0"
      [attr.aria-label]="ariaLabel()"
      (click)="activate()"
      (keydown)="onKeydown($event)"
    >
      <picture>
        @if (thumbnailSrcMax()) {
          <source [srcset]="thumbnailSrcMax()" type="image/jpeg" />
        }
        <img
          class="sam-video__thumb"
          [src]="thumbnailFallback()"
          [alt]="'Video thumbnail — ' + title()"
          loading="lazy"
          width="720"
          height="405"
        />
      </picture>
      <svg
        class="sam-video__play"
        viewBox="0 0 68 48"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74 0.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"
          fill="#f00"
        />
        <path d="M45 24 27 14v20" fill="#fff" />
      </svg>
    </div>
  } @else {
    <iframe
      class="sam-video__iframe"
      [src]="iframeSrc()"
      [title]="ariaLabel()"
      allow="autoplay; encrypted-media; fullscreen"
      allowfullscreen
      loading="lazy"
    ></iframe>
  }

  @if (caption()) {
    <p class="sam-video__caption">{{ caption() }}</p>
  }

</div>
